export class DictionariesConstants {
    public static Voivodeships: string = "VOIVODESHIPS";
    public static SettlementPeriod: string = "SETTLEMENT_PERIOD";
    public static EndContractReason: string = "END_CONTRACT_REASON";
    public static NHFContract: string = "NHF_CONTRACT";
    public static OrderCancellationReason: string = "ORDER_CANCELLATION_REASON";
    public static TrueOrFalse: string = "TRUE_OR_FALSE";
}
